export default "__VITE_ASSET__AmgAhNPI__"